module.exports = __webpack_public_path__ + "static/media/beepSound2.53cd88a4.wav";